
const apiBaseUrl = process.env.REACT_APP_API_URL || "https://api.infinityapply.com/api/";
// const apiBaseUrl = process.env.REACT_APP_API_URL || "http://localhost:5242/api/";
const assetBaseUrl = process.env.REACT_APP_API_ASSET_URL || "https://api.infinityapply.com/uploads/";

export const apiUrl = apiBaseUrl.replace(/\/$/, "") + "/";
export const apiAsset = assetBaseUrl.replace(/\/$/, "") + "/";
